<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
      <sub-tabs nomeSessao="Relatórios" :tabs="tabs"></sub-tabs>
  </v-container>
</template>

<script>
import subTabs from '@/components/painel/SubTabs'
export default {
  name: 'PRelatorios',
  components: {
    'sub-tabs': subTabs
  },
  data () {
    return {
      tabs: [
        // {
        //   nome: 'Itens mais solicitados',
        //   url: 'Itens'
        // },
        {
          nome: 'Pedidos',
          url: 'Condominios'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?714cf800